module.exports = __webpack_public_path__ + "img/hz1.a69b6c62.png";